import { Link } from 'react-router-dom';

const navLinks = [
  { label: 'Accueil', path: '/' },
  { label: 'À propos', path: '/a-propos' },
  { label: 'Contact', path: '/contact' },
  { label: 'Conditions générales', path: '/conditions-generales' },
  { label: 'Politique de confidentialité', path: '/politique-confidentialite' },
];

export default function Footer() {
  return (
    <footer className="bg-[#1A2B4A] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/8259da15-e112-4849-b454-da1593529b79.png"
              alt="SOMINKA"
              className="h-10 w-auto mb-5"
            />
            <p className="text-gray-300 text-sm leading-relaxed mb-6">
              Conseil en affaires et gestion à Bordeaux. Accompagnement des entrepreneurs et entreprises dans le développement de leur activité.
            </p>
            <div className="border-t border-white/10 pt-5 space-y-1">
              <p className="text-gray-400 text-xs">Amelia Anna Sominka</p>
              <p className="text-gray-400 text-xs">SIRET : 101 634 145 00011</p>
              <p className="text-gray-400 text-xs">Code NAF : 70.22Z</p>
            </div>
          </div>

          <div>
            <h3 className="text-xs font-semibold uppercase tracking-widest text-gray-400 mb-6">Navigation</h3>
            <ul className="flex flex-col gap-3">
              {navLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-gray-300 hover:text-white transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-xs font-semibold uppercase tracking-widest text-gray-400 mb-6">Contact</h3>
            <ul className="flex flex-col gap-5">
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-map-pin-line text-gray-400 text-sm"></i>
                </div>
                <span className="text-sm text-gray-300 leading-relaxed">
                  4 Rue Judaïque<br />33000 Bordeaux<br />France
                </span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-gray-400 text-sm"></i>
                </div>
                <a
                  href="tel:+33682533668"
                  className="text-sm text-gray-300 hover:text-white transition-colors"
                >
                  +33 6 82 53 36 68
                </a>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-gray-400 text-sm"></i>
                </div>
                <a
                  href="mailto:ameliasominkaaa@outlook.com"
                  className="text-sm text-gray-300 hover:text-white transition-colors break-all"
                >
                  ameliasominkaaa@outlook.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-gray-400 text-xs">
            © {new Date().getFullYear()} SOMINKA – Tous droits réservés
          </p>
          <div className="flex items-center gap-4">
            <Link
              to="/conditions-generales"
              className="text-gray-400 hover:text-white text-xs transition-colors cursor-pointer whitespace-nowrap"
            >
              Conditions générales
            </Link>
            <span className="text-gray-600 text-xs">|</span>
            <Link
              to="/politique-confidentialite"
              className="text-gray-400 hover:text-white text-xs transition-colors cursor-pointer whitespace-nowrap"
            >
              Politique de confidentialité
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
